<div class="admin-page">
  <header class="admin-header">
    <div class="admin-header__identity">
      <div class="admin-header__icon" aria-hidden="true">
        <i class="pi pi-shield"></i>
      </div>
      <div class="admin-header__copy">
        <h1>Administration</h1>
        <p>Users <span>&middot;</span> Sign-in activity <span>&middot;</span> Report schedule</p>
      </div>
    </div>
  </header>

  <div class="admin-content">
  <div class="surface-panel">
    <p-tabView>
      <p-tabPanel header="Users">
        <div class="tab-toolbar">
          <button
            pButton
            type="button"
            label="Add user"
            icon="pi pi-user-plus"
            (click)="openCreateDialog()"
          ></button>
        </div>

        <p-table [value]="users" [loading]="loadingUsers" dataKey="id">
          <ng-template pTemplate="header">
            <tr>
              <th>Email</th>
              <th>Name</th>
              <th>Role</th>
              <th>Status</th>
              <th class="actions-col">Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-user>
            <tr>
              <td>{{ user.email }}</td>
              <td>{{ user.full_name || '—' }}</td>
              <td>
                <span
                  *ngIf="user.is_superuser"
                  class="role-tag role-tag--admin"
                  pTooltip="The superuser role cannot be changed here"
                  >Superuser</span
                >
                <p-dropdown
                  *ngIf="!user.is_superuser"
                  [options]="roleOptions"
                  [ngModel]="primaryRoleId(user)"
                  (onChange)="onRoleChange(user, $event.value)"
                  [disabled]="savingRoleFor === user.id"
                  styleClass="role-dropdown"
                  appendTo="body"
                ></p-dropdown>
              </td>
              <td>
                <span
                  class="status-dot"
                  [class.status-dot--off]="!user.is_active"
                ></span>
                {{ user.is_active ? 'Active' : 'Deactivated' }}
              </td>
              <td class="actions-col">
                <button
                  pButton
                  type="button"
                  class="p-button-text p-button-sm"
                  icon="pi pi-pencil"
                  pTooltip="Edit name / email"
                  (click)="openEditDialog(user)"
                ></button>
                <button
                  pButton
                  type="button"
                  class="p-button-text p-button-sm"
                  icon="pi pi-key"
                  pTooltip="Set password"
                  (click)="openPasswordDialog(user)"
                ></button>
                <button
                  pButton
                  type="button"
                  class="p-button-text p-button-sm"
                  icon="pi pi-envelope"
                  pTooltip="Send reset link"
                  (click)="sendReset(user)"
                ></button>
                <button
                  pButton
                  type="button"
                  class="p-button-text p-button-sm"
                  icon="pi pi-desktop"
                  pTooltip="Sessions"
                  (click)="openSessions(user)"
                ></button>
                <button
                  pButton
                  type="button"
                  class="p-button-text p-button-sm"
                  [icon]="user.is_active ? 'pi pi-ban' : 'pi pi-check-circle'"
                  [pTooltip]="user.is_active ? 'Deactivate' : 'Activate'"
                  [disabled]="user.is_superuser"
                  (click)="toggleActive(user)"
                ></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Login activity">
        <p-table
          [value]="activity"
          [loading]="loadingActivity"
          [paginator]="true"
          [rows]="activityRows"
          [totalRecords]="activityTotal"
          [lazy]="true"
          (onLazyLoad)="onActivityPage($event)"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>User</th>
              <th>Signed in</th>
              <th>Last activity</th>
              <th>IP</th>
              <th>Client</th>
              <th>Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-entry>
            <tr>
              <td>{{ entry.email }}</td>
              <td>{{ entry.signed_in_at | date : 'yyyy-MM-dd HH:mm' }}</td>
              <td>
                {{
                  entry.last_used_at
                    ? (entry.last_used_at | date : 'yyyy-MM-dd HH:mm')
                    : '—'
                }}
              </td>
              <td>{{ entry.ip_address || '—' }}</td>
              <td class="client-col" [title]="entry.user_agent">
                {{ entry.user_agent || '—' }}
              </td>
              <td>
                <span class="role-tag" [class.role-tag--admin]="entry.is_revoked">
                  {{ entry.is_revoked ? 'revoked' : 'active' }}
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Audit trail">
        <p-table
          [value]="audit"
          [loading]="loadingAudit"
          [paginator]="true"
          [rows]="auditRows"
          [totalRecords]="auditTotal"
          [lazy]="true"
          (onLazyLoad)="onAuditPage($event)"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>When</th>
              <th>Who</th>
              <th>Action</th>
              <th>Record</th>
              <th>Changed</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-entry>
            <tr>
              <td>{{ entry.date_created | date : 'yyyy-MM-dd HH:mm' }}</td>
              <td>{{ entry.actor_email || 'system' }}</td>
              <td>
                <span
                  class="role-tag"
                  [class.role-tag--admin]="entry.action === 'delete'"
                  >{{ entry.action }}</span
                >
              </td>
              <td>
                {{ entry.entity_label || entry.entity_type }}
                <span class="entity-type">{{ entry.entity_type }}</span>
              </td>
              <td class="client-col">{{ changeSummary(entry) }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Email log">
        <p-table
          [value]="emails"
          [loading]="loadingEmails"
          [paginator]="true"
          [rows]="emailRows"
          [totalRecords]="emailsTotal"
          [lazy]="true"
          (onLazyLoad)="onEmailPage($event)"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Sent</th>
              <th>To</th>
              <th>Type</th>
              <th>Subject</th>
              <th>Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-mail>
            <tr>
              <td>{{ mail.created_at | date : 'yyyy-MM-dd HH:mm' }}</td>
              <td>{{ mail.to_address }}</td>
              <td>{{ mail.kind || '—' }}</td>
              <td>{{ mail.subject }}</td>
              <td>
                <span
                  class="role-tag"
                  [class.role-tag--admin]="mail.status !== 'sent'"
                  [pTooltip]="mail.error || ''"
                  >{{ mail.status }}</span
                >
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Report schedule">
        <div class="schedule-form" *ngIf="schedule">
          <p class="schedule-hint">
            The active-issues report is emailed to admin users on this
            schedule (times are South African time). Changes take effect
            within the hour.
          </p>

          <div class="schedule-grid">
            <label>
              <span>Enabled</span>
              <p-inputSwitch [(ngModel)]="schedule.enabled"></p-inputSwitch>
            </label>

            <label>
              <span>Frequency</span>
              <p-dropdown
                [options]="frequencyOptions"
                [(ngModel)]="schedule.frequency"
              ></p-dropdown>
            </label>

            <label *ngIf="schedule.frequency === 'weekly'">
              <span>Day of week</span>
              <p-dropdown
                [options]="weekdayOptions"
                [(ngModel)]="schedule.weekday"
              ></p-dropdown>
            </label>

            <label *ngIf="schedule.frequency === 'monthly'">
              <span>Day of month</span>
              <p-inputNumber
                [(ngModel)]="schedule.day_of_month"
                [min]="1"
                [max]="28"
              ></p-inputNumber>
            </label>

            <label>
              <span>Time</span>
              <p-dropdown
                [options]="hourOptions"
                [(ngModel)]="schedule.hour"
              ></p-dropdown>
            </label>
          </div>

          <div class="schedule-actions">
            <span class="schedule-last-sent">
              Last sent:
              {{
                schedule.last_sent_at
                  ? (schedule.last_sent_at | date : 'yyyy-MM-dd HH:mm')
                  : 'never'
              }}
            </span>
            <button
              pButton
              type="button"
              label="Save schedule"
              icon="pi pi-save"
              [loading]="savingSchedule"
              (click)="saveSchedule()"
            ></button>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="AI & Predictions">
        <div class="ai-form">
          <p class="schedule-hint">
            Predictive maintenance flags at-risk vehicles from their service
            history — this always works with no setup. Adding an AI provider
            here layers a short fault prediction onto each flagged vehicle.
            Choose the provider and model, paste that provider's API key, and
            it becomes the one used for predictions. The key is stored
            encrypted and never shown again. You can switch provider or model
            any time — nothing is fixed in configuration.
          </p>

          <div class="ai-status" [class.ai-status--on]="activeProvider?.has_api_key">
            <i
              [class]="
                activeProvider?.has_api_key
                  ? 'pi pi-check-circle'
                  : 'pi pi-info-circle'
              "
            ></i>
            <span *ngIf="activeProvider?.has_api_key">
              Key configured for {{ selectedProvider }} ·
              {{ activeProvider.model_name }}{{ activeProvider.is_default ? ' — active for predictions' : '' }}.
            </span>
            <span *ngIf="!activeProvider?.has_api_key">
              No key for {{ selectedProvider }} yet — predictions show
              rule-based flags only until you add one.
            </span>
          </div>

          <div class="schedule-grid">
            <label>
              <span>Provider</span>
              <p-dropdown
                [options]="providerOptions"
                [ngModel]="selectedProvider"
                (onChange)="onProviderChange($event.value)"
                appendTo="body"
              ></p-dropdown>
            </label>

            <label>
              <span>Model</span>
              <p-dropdown
                [options]="providerModelOptions"
                [(ngModel)]="providerModel"
                [editable]="true"
                appendTo="body"
              ></p-dropdown>
            </label>

            <label>
              <span>API key {{ activeProvider?.has_api_key ? '(leave blank to keep)' : '' }}</span>
              <input
                pInputText
                type="password"
                autocomplete="off"
                [placeholder]="selectedProvider === 'anthropic' ? 'sk-ant-…' : 'sk-…'"
                [(ngModel)]="providerApiKey"
              />
            </label>
          </div>

          <div class="schedule-actions">
            <button
              pButton
              type="button"
              label="Test key"
              icon="pi pi-bolt"
              class="p-button-outlined"
              [loading]="testingProvider !== null"
              [disabled]="!activeProvider?.has_api_key"
              (click)="testProvider()"
            ></button>
            <button
              pButton
              type="button"
              label="Save provider"
              icon="pi pi-save"
              [loading]="savingProvider"
              [disabled]="!activeProvider && !providerApiKey.trim()"
              (click)="saveProvider()"
            ></button>
          </div>

          <hr class="ai-divider" />

          <p class="schedule-hint">
            Predictions recompute automatically every night. Use this to
            refresh them now — for example right after adding an AI key.
          </p>
          <div class="schedule-actions">
            <button
              pButton
              type="button"
              label="Recompute predictions now"
              icon="pi pi-refresh"
              class="p-button-outlined"
              [loading]="recomputing"
              (click)="recomputePredictions()"
            ></button>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>

  <p-dialog
    header="Add user"
    [(visible)]="createDialogVisible"
    [modal]="true"
    [style]="{ width: '420px' }"
  >
    <div class="create-user-form">
      <label>
        <span>Email</span>
        <input pInputText type="email" [(ngModel)]="newUserEmail" />
      </label>
      <label>
        <span>Full name (optional)</span>
        <input pInputText type="text" [(ngModel)]="newUserFullName" />
      </label>
      <label>
        <span>Role</span>
        <p-dropdown
          [options]="roleOptions"
          [(ngModel)]="newUserRoleId"
          appendTo="body"
        ></p-dropdown>
      </label>
      <p class="schedule-hint">
        The new user receives an email invite to choose their own password.
        Viewer can see fleet data but not change it; operator can change it;
        admin also manages users and settings.
      </p>
    </div>
    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-text"
        (click)="createDialogVisible = false"
      ></button>
      <button
        pButton
        type="button"
        label="Send invite"
        icon="pi pi-send"
        [loading]="creatingUser"
        [disabled]="!newUserEmail.trim()"
        (click)="createUser()"
      ></button>
    </ng-template>
  </p-dialog>

  <p-dialog
    header="Edit user"
    [(visible)]="editDialogVisible"
    [modal]="true"
    [style]="{ width: '420px' }"
  >
    <div class="create-user-form">
      <label>
        <span>Email</span>
        <input pInputText type="email" [(ngModel)]="editEmail" />
      </label>
      <label>
        <span>Full name</span>
        <input pInputText type="text" [(ngModel)]="editFullName" />
      </label>
    </div>
    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-text"
        (click)="editDialogVisible = false"
      ></button>
      <button
        pButton
        type="button"
        label="Save"
        icon="pi pi-check"
        [loading]="savingEdit"
        [disabled]="!editEmail.trim()"
        (click)="saveEdit()"
      ></button>
    </ng-template>
  </p-dialog>

  <p-dialog
    [header]="'Set password — ' + (passwordUser?.email || '')"
    [(visible)]="passwordDialogVisible"
    [modal]="true"
    [style]="{ width: '420px' }"
  >
    <div class="create-user-form">
      <label>
        <span>New password</span>
        <input pInputText type="text" [(ngModel)]="newPassword" autocomplete="off" />
      </label>
      <p class="schedule-hint">
        Sets the password directly. Prefer "Send reset link" so the user
        chooses their own — use this only when you need to hand a password
        over yourself.
      </p>
    </div>
    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-text"
        (click)="passwordDialogVisible = false"
      ></button>
      <button
        pButton
        type="button"
        label="Set password"
        icon="pi pi-key"
        [loading]="savingPassword"
        [disabled]="!newPassword.trim()"
        (click)="setPassword()"
      ></button>
    </ng-template>
  </p-dialog>

  <p-dialog
    [header]="'Sessions — ' + (sessionsUser?.email || '')"
    [(visible)]="sessionsDialogVisible"
    [modal]="true"
    [style]="{ width: '640px' }"
  >
    <p-table [value]="sessions">
      <ng-template pTemplate="header">
        <tr>
          <th>Signed in</th>
          <th>IP</th>
          <th>Client</th>
          <th>Status</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-session>
        <tr>
          <td>{{ session.date_created | date : 'yyyy-MM-dd HH:mm' }}</td>
          <td>{{ session.ip_address || '—' }}</td>
          <td class="client-col" [title]="session.user_agent">
            {{ session.user_agent || '—' }}
          </td>
          <td>{{ session.is_revoked ? 'revoked' : 'active' }}</td>
          <td>
            <button
              pButton
              type="button"
              class="p-button-text p-button-sm p-button-danger"
              icon="pi pi-times"
              pTooltip="Revoke"
              [disabled]="session.is_revoked"
              (click)="revokeSession(session)"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-dialog>
</div>
